module.exports = __webpack_public_path__ + "static/media/img2.ebe92a58.jpg";